import axiosInstance from './axiosInstance';

const cmsPageService = {
  list: (params = {}) => axiosInstance.get('/admin/pages', { params }),
  getById: (id) => axiosInstance.get(`/admin/pages/${id}`),
  create: (data) => axiosInstance.post('/admin/pages', data),
  update: (id, data) => axiosInstance.put(`/admin/pages/${id}`, data),
  remove: (id) => axiosInstance.delete(`/admin/pages/${id}`),
};

export default cmsPageService;
